<template>
    <div>
        <div v-if="tickets && tickets.length>0" class="card hide-while-loading">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>{{ app.lang.assetName }}</th>
                                <th>Reference</th>
                                <th>Logged</th>
                                <th>Details</th>
                                <th class="text-right">Value</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr v-for="ticket in tickets" :key="ticket.id">

                                <td class="align-text-top" style="min-width: 220px">
                                    {{ ticket.asset_name }}<br>
                                </td>

                                <td class="align-text-top">
                                    <span class="text-muted"> {{ ticket.ticket_reference_number }} <span class="label label-light-primary"
                                                                                                         style="padding: 2px">{{ ticket.status }}</span>
                                    </span>
                                </td>

                                <td class="align-text-top">
                                    <span class="text-muted"> {{ ticket.logged_at | dateShort }}</span>
                                </td>

                                <td class="align-text-top"><p class="mb-0 font-weight-normal">
                                    <span v-if="ticket.primary_tenant_name" class="label label-light-primary"
                                          style="padding: 2px">Tenant</span> {{ ticket.primary_tenant_name }}</p>
                                    <p class="mb-0 text-muted small">{{ ticket.description }}</p>
                                </td>

                                <td class="align-text-top text-right">
                                    <span v-if="ticket.contracted_value">{{ ticket.contracted_value }}</span>
                                </td>

                                <td class="align-text-top text-right">
                                    <a class="btn btn-rounded btn-outline-primary btn-sm" href="#"
                                       @click.prevent="goToTicket(ticket.id)">View
                                    </a>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>

                <div class="vuetable-pagination-info p-0 pr-2 pull-left">Displaying {{ from }} to {{ to }} of {{ total }}
                    items
                </div>

                <el-pagination
                    class="pull-right"
                    background
                    small
                    @current-change="fetchTickets"
                    layout="prev, pager, next"
                    :page-size="pageSize"
                    :total="total">
                </el-pagination>

            </div>
        </div>

        <!--Empty View displayed if there are no ticket follow up reminders-->
        <div v-else class="card hide-while-loading text-center">
            <div class="card-body">
                <h4 class="card-title">No Tickets</h4>
                <div class="text-center">
                    <span class="">No tickets assigned to this service provider yet.</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ticket-list",

    props: ["listUrl"],

    data () {
        return {
            tickets: {},
            total: 0,
            from: 0,
            to: 0,
            pageSize: 10
        };
    },

    mounted () {
        this.fetchTickets();
    },

    methods: {
        goToTicket (ticketId) {
            window.location = "/tickets/" + ticketId;
        },

        fetchTickets (page) {
            let self = this;
            axios.get(self.listUrl, {
                params: {
                    page: page
                }
            }).then((response) => {
                self.tickets = response.data.data;
                this.setPaginationData(response.data);
            }).catch(() => {
                toastr.error("Could not fetch tickets!");
            });
        },

        setPaginationData (paginationData) {
            this.total = paginationData.total;
            this.from = paginationData.from;
            this.to = paginationData.to;
        }
    }
};
</script>

<style scoped>

</style>
